import { useMutation } from "@tanstack/react-query";
import { CartItem, useCart } from "../../context/CartContext";
import { useChair } from "../../context/ChairContext";

const url = "/actions/order-confirmation-module/order-confirmation/";

type CartCookie = {
    cart: CartItem[];
    note: string;
};

const getExpirationString = () => {
    const now = new Date();
    now.setTime(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    return "expires=" + now.toUTCString();
};

export const usePlaceOrder = () => {
    const { cart, note, empty } = useCart();
    const { reset } = useChair();

    const cookie: CartCookie = {
        cart: cart,
        note: note,
    };

    document.cookie = `at-meinstuhl-warenkorb=${JSON.stringify(cookie)}; ${getExpirationString()}`;

    return useMutation({
        mutationKey: [],
        mutationFn: async () => {
            return fetch(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                },
            });
        },
        onSuccess: (response) => {
            if (response.status === 200) {
                empty();
                reset({ id: "" });
                document.cookie = `at-meinstuhl-warenkorb=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
            }
        },
    });
};
